import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";

function PlotlyChart({ plotlyJson }) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 700);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!plotlyJson) return null;

  let fig;
  try {
    fig = typeof plotlyJson === "string" ? JSON.parse(plotlyJson) : plotlyJson;
  } catch {
    return <div>Invalid chart data</div>;
  }

  const { width: _ignoredWidth, height: _ignoredHeight, ...baseLayout } = fig.layout || {};

  // Keep figure styling consistent while letting Plotly resize naturally for narrow screens.
  const fontFamily = "'Segoe UI', 'Roboto', 'Arial', sans-serif";
  const baseFontSize = isMobile ? 12 : 17;
  const axisFontSize = isMobile ? 11 : 15;
  const titleFontSize = isMobile ? 15 : 20;
  const legendFont = baseLayout.legend?.font || {};
  const legendFontFamily = legendFont.family || fontFamily;
  const legendFontSize = legendFont.size || baseFontSize;

  const updatedLayout = {
    ...baseLayout,
    autosize: true,
    margin: {
      ...baseLayout.margin,
      l: isMobile ? 28 : (baseLayout.margin?.l ?? 72),
      r: isMobile ? 8 : (baseLayout.margin?.r ?? 36),
      t: isMobile ? 52 : (baseLayout.margin?.t ?? 82),
      b: isMobile ? 46 : (baseLayout.margin?.b ?? 66),
    },
    font: {
      family: fontFamily,
      size: baseFontSize,
    },
    title: {
      ...baseLayout.title,
      x: 0.5,
      xanchor: "center",
      font: {
        family: fontFamily,
        size: titleFontSize,
        weight: "bold",
      },
    },
    xaxis: {
      ...baseLayout.xaxis,
      automargin: true,
      nticks: isMobile ? 6 : baseLayout.xaxis?.nticks,
      tickangle: isMobile ? -30 : baseLayout.xaxis?.tickangle,
      title: {
        ...baseLayout.xaxis?.title,
        standoff: isMobile ? 12 : 18,
        font: {
          family: fontFamily,
          size: baseFontSize,
        },
      },
      tickfont: {
        family: fontFamily,
        size: axisFontSize,
      },
    },
    yaxis: {
      ...baseLayout.yaxis,
      automargin: true,
      title: {
        ...baseLayout.yaxis?.title,
        standoff: isMobile ? 8 : 18,
        font: {
          ...legendFont,
          family: legendFontFamily,
          size: legendFontSize,
        },
      },
      tickfont: {
        family: fontFamily,
        size: axisFontSize,
      },
    },
  };

  const updatedConfig = {
    ...fig.config,
    responsive: true,
    displayModeBar: false,
    displaylogo: false,
  };

  return (
    <Plot
      data={fig.data}
      layout={updatedLayout}
      config={updatedConfig}
      frames={fig.frames}
      useResizeHandler
      style={{ width: "100%", height: isMobile ? "340px" : "420px" }}
    />
  );
}

export default PlotlyChart;